import { render } from "./PostCard.vue?vue&type=template&id=0d388710&ts=true"
import script from "./PostCard.vue?vue&type=script&lang=ts"
export * from "./PostCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__